import React from 'react'
import PropTypes from 'prop-types'
import Apartment from '@mui/icons-material/Apartment'

const ApartmentIcon = ({ height, width, ...more }) => {
	
	return (
		<Apartment
			height={height}
			width={width}
			{...more}
		/>
	)
}

ApartmentIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default ApartmentIcon
